import {createApp } from 'vue';
import App from './App.vue';
import router from './router';
import { ApplicationInsights } from '@microsoft/applicationinsights-web';

const notSupportedElement = document.getElementById('browserNotSupportedError');
if (notSupportedElement)
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  //@ts-ignore window.fetch produces error on build, but it is required for feature check. The use case is showing a friendly error message on IE11
  notSupportedElement.style.display = window.fetch ? 'none' : 'block';

import vuetify from '@/plugins/vuetify';
import '@/styles/styles.scss';

// Load custom tenant css. 
// The tenantid is the second part of the path
// Note: there is a dependency to the path structure. Sync this with routes in router.ts.
const tenantIdRegex = '^/([^/]+)/([^?|/]+)'
const regexResult = window.location.pathname.match(tenantIdRegex)

if(regexResult != null) {
  const tenantId = regexResult[2]
  
  if(tenantId != null && tenantId.length > 0) {
    const link = document.createElement("link");
    link.href = `/api/${tenantId}/Sign/tenant/custom.css`
    link.type = "text/css";
    link.rel = "stylesheet";
    document.getElementsByTagName("head")[0].appendChild(link);
  }
}



const main = createApp(  
  App
);
main.use(router);

import { createI18n } from '@/eSign-i18n';
const i18n = createI18n();
main.use(i18n);
main.use(vuetify(i18n));

main.mount('#root');


import {store} from './store';
fetch('/api/.common/config')
  .then((response) => {
    const contentType = response.headers.get('Content-Type');

    if (response.ok && contentType && contentType.indexOf('application/json') >= 0) {
      response.json().then((responseJson) => {
        const applicationInsightsConnectionString = responseJson.applicationInsightsConnectionString;
        if(applicationInsightsConnectionString) {
          const appInsights = new ApplicationInsights({
            config: {
              connectionString: applicationInsightsConnectionString,
              // disable fetching a ms hosted config file
              // the purpose of the config file is unclear, so if it becomes useful, we can re-evaluate this decision
              // note, if loading is enabled, content security policy needs to allow loading it (currently, it loads a json from  https://js.monitor.azure.com/ so that needs to be allowed in connect-src)
              // links:
              // https://github.com/microsoft/ApplicationInsights-JS?tab=readme-ov-file#service-notification
              // https://github.com/microsoft/ApplicationInsights-JS/blob/main/docs/WebConfig.md#disable-fetching-from-cdn
              // https://github.com/microsoft/ApplicationInsights-JS/issues/2341
              extensionConfig: {
                ["AppInsightsCfgSyncPlugin"]: {
                    cfgUrl: "" // this will block fetching from default cdn
                }
              }
            },
          });
          appInsights.loadAppInsights();
          appInsights.trackPageView(); // Manually call trackPageView to establish the current user/session/pageview

          delete responseJson.applicationInsightsConnectionString;
        }
        if(responseJson.environmentName)
          store.environmentName = responseJson.environmentName;
      }).catch(err => {
        console.warn('error parsing config response', err);
      });
    }
  });

export default main;
